import { Validators } from '@angular/forms';
import { CmValidators } from '../../validators';

export const DEFAULT_DOCUMENTATION_VALIDATORS = [CmValidators.fileSizeValidator(20), Validators.maxLength(5)];
